<template>
  <div id="header-user">
    <i class="el-icon-user"></i>
    {{ userName }}<span class="divider">|</span><span class="logout" @click="logout">退出登录</span>
  </div>
</template>

<script>
import ssoWeb from '@/lib/SSO'
import { sendMetricLog } from '@/utils'
import store from '@/store'

export default {
  name: 'HeaderUser',
  data() {
    return {
      userName: '',
    }
  },
  created() {
    this.fetch
      .get('commonUserInfo')
      .then((res) => {
        const { data = {} } = res
        this.userName = data.login || ''
        window.__BIKE_POLARIS__.empId = data.id
        window.__BIKE_POLARIS__.mis = data.login
        window.__BIKE_POLARIS__.userName = data.name
        store.commit('updateLoginUserName', this.userName)
        // 埋点
        sendMetricLog({
          key: 'loginMis',
          tags: {
            mis: data.login || '未知',
          },
        })
        // 修改 owl unionId
        try {
          window.owl('setDimension', {
            unionId: data.login || '',
          })
        } catch (e) {
          console.error(e)
        }
      })
      .catch(() => {})
  },
  methods: {
    logout() {
      ssoWeb.logout()
      setTimeout(() => {
        window.location.reload()
      }, 100)
    },
  },
}
</script>

<style scoped lang="scss">
#header-user {
  padding: 0 20px;
  color: rgba(255, 255, 255, 0.84);
  line-height: 60px;
  display: block;
  outline: none;
  font-size: 14px;
  .divider {
    padding: 0 20px;
    color: rgba(255, 255, 255, 0.24);
  }
  .logout {
    cursor: pointer;
    &:hover {
      color: #fff;
    }
  }
  .iconfont {
    font-size: 12px;
  }
}
</style>
